import { Box, Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';

function CallToAction() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  useEffect(() => {
    // we need to remove and reload the script to force Salsa to update the div.
    const existingScript = document.getElementById('accessSalsa');
    if (existingScript) {
      document.body.removeChild(existingScript);
    }
    const script = document.createElement('script');
    script.src = 'https://default.salsalabs.org/api/widget/template/197a83cb-7d3b-46ea-a83b-33cdc5ece475/?tId=452d5b11-d7a8-41ac-a0a9-9e05184448df';
    script.id = 'accessSalsa';
    document.body.appendChild(script);
  });

  return (
    <Box displayPrint="none">
      <SubquestionBox color={lightColor}>
        <Grid
          spacing={2}
          container
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
              Call to action
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={10} sm={6}>
                <MessageBox>
                  <Box className="ccdc-salsa">
                    <Box id="452d5b11-d7a8-41ac-a0a9-9e05184448df" className="ccdc-salsa" />
                  </Box>
                </MessageBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SubquestionBox>
    </Box>
  );
}

export default CallToAction;
